module.exports = __webpack_public_path__ + "img/price-4-star.0b25e86e.png";